import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { MediaQueries } from "../components/utils";
import Paymentdetails from "../components/Common/Paymentdetails";
import { setselecteddefaultpaymentmethod, setselecteddeafultoption } from "../redux/paymentslice";
import Breadcomp from "../components/Common/Breadcomp";
import Donation from "../components/Common/Donation";
import { IoCheckbox } from "react-icons/io5";
import infoimg from "../../src/images/Info Square.png";
import donateimg1 from "../../src/images/Frame 1321316476.png";
import donateimg2 from "../../src/images/Frame 1321316477.png";
import CheckCoupan from "../components/Common/CheckCoupan";
import { pushToDataLayer } from "../components/utils/dataUserpush"

const Payment = () => {
    // alert()
    const dispatch = useDispatch();
    const logindata = useSelector((state) => state.formslice.logindata);
    const paymentmethodsdata = useSelector((state) => state.paymentslice.paymentmethodsdata);
    const selecteddeafultoption = useSelector((state) => state.paymentslice.selecteddeafultoption);
    const selecteddefaultpaymentmethod = useSelector((state) => state.paymentslice.selecteddefaultpaymentmethod);
    const { isMobile } = MediaQueries();
    const [selectedpaymentmethod, setSelectedPaymentMethod] = useState(null);
    const [selectedprocessing_fee, setSelectedprocessing_fee] = useState("");
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    useEffect(() => {
        pushToDataLayer("view_payment_page", currentcountry.name, {
            payment_method: selecteddeafultoption[0]?.payment_method,
            amount: paymentmethodsdata.final_total
        });
    }, []);

    useEffect(() => {
        dispatch(setselecteddeafultoption(paymentmethodsdata?.payment_method?.filter(ele => ele.id == selecteddefaultpaymentmethod)))
    }, [paymentmethodsdata, selecteddefaultpaymentmethod])

    const handlePaymentChange = (id, processing_fee) => {
        dispatch(setselecteddefaultpaymentmethod(id));
        setSelectedprocessing_fee(processing_fee)
        pushToDataLayer("clicked_paymentmethod", currentcountry.name, {
            payment_method: selecteddeafultoption[0]?.payment_method
        });

    };
    return (
        <div className="mobile-marginbottom">
            <Container fluid className="homepagecontainer">
                <div className={`${isMobile ? 'pt-1 pb-1' : 'pt-3 pb-3'}`}>
                    <Breadcomp />
                </div>

                <div className="Cart-titile">Select Payment Method</div>
                <Row>
                    <Col lg={8}>
                        <div className="Cartitem-maindiv">
                            {paymentmethodsdata?.payment_method?.map((ele, index) => (
                                <div >
                                    <div key={ele.id} className="d-flex align-items-center cursor-pointer">
                                        <input
                                            type="radio"
                                            name="payment"
                                            value={ele.id}
                                            checked={selecteddefaultpaymentmethod === ele.id}
                                            onChange={() => handlePaymentChange(ele.id, ele.processing_fee)}
                                            className="me-2 payment-radiobtn"
                                        />
                                        <div onClick={() => handlePaymentChange(ele.id, ele.processing_fee)}>
                                            <div className="paymentmethod-label">  {ele.image && (
                                                <img src={ele.image} alt={ele.label} className="paymentmethod-image" />
                                            )}{ele.label}</div>
                                            <div className="paymentmethod-sublabel">{ele.sub_label}</div>
                                        </div>

                                    </div>
                                    {index !== paymentmethodsdata.payment_method.length - 1 && (
                                        <div className="payment-border-bottom"></div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col lg={4}>
                        <div className={!isMobile ? "pricedetails" : "p-2 mobilepricedetails"}>
                            <div className="ordersummary-title">Order Summary</div>
                            <div className="payment-border-bottom"></div>
                            <CheckCoupan />
                            {
                                isMobile &&
                                <div className="payment-border-bottom"></div>
                            }
                            {
                                currentcountry.isDonationRequired &&
                                <Donation donation={paymentmethodsdata?.donation} />
                            }
                            {
                                //  isMobile &&
                                <div className="payment-border-bottom"></div>
                            }
                            <Paymentdetails />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Payment;



